//const API_BASE_URL = "https://btestcoop.litechdev.com/api"; // ⚠️ Ajustalo si usás diferente puerto o dominio
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/api"; // ⚠️ Ajustalo si usás diferente puerto o dominio

export default API_BASE_URL;